import cmp from './_compiler.js'
import stubVNode from './stub-vnode'

/**
 * Basic ol component with stub VNode, i.e. virtual component
 */
export default {
  mixins: [stubVNode, cmp],
  methods: {
    /**
     * @return {Promise}
     * @protected
     */
    init () {
      // console.log("Init v-compiler")
      return cmp.methods.init.call(this)
    },
    /**
     * @return {void|Promise<void>}
     * @protected
     */
    deinit () {
      return cmp.methods.deinit.call(this)
    },
    /**
     * @return {*}
     * @protected
     * @abstract
     */
    createOlObject () {
      throw new Error('Not implemented method')
    },
    /**
     * Redefine for easy call in child components
     * @returns {Object}
     * @protected
     */
    getServices () {
      return cmp.methods.getServices.call(this)
    },
    /**
     * Refresh internal ol objects
     * @return {Promise}
     */
    refresh () {
      return cmp.methods.refresh.call(this)
    },
  },
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/compilers/v-compiler.js